import * as React from 'react';
import NoPlayer from '../ReqHlsVideo/NoPlayer';
import AdaptivePlayer from './AdaptivePlayer';
import { Props as VideoProps } from './index';
import { SelectedPlayer } from './PlayerSelection';
import ProgressivePlayer from './ProgressivePlayer';

interface Props extends VideoProps {
  selectedPlayer: SelectedPlayer;
}

const RenderedPlayer: React.FC<Props> = (props) => {
  switch (props.selectedPlayer.kind) {
    case 'undetermined':
      return <span />;
    case 'progressive-low':
    case 'edge':
    case 'progressive':
      return (
        <ProgressivePlayer
          id={props.id}
          className={props.className}
          videoResource={props.videoResource}
          kettle={props.kettle}
          width={props.width}
          height={props.height}
          dynamicallySetAspectRatio={props.dynamicallySetAspectRatio}
          sources={props.selectedPlayer.sources.toArray()}
        />
      );
    case 'adaptive':
      return (
        <AdaptivePlayer
          id={props.id}
          className={props.className}
          videoResource={props.videoResource}
          kettle={props.kettle}
          width={props.width}
          height={props.height}
          dynamicallySetAspectRatio={props.dynamicallySetAspectRatio}
        />
      );
    case 'no-selection':
      return <NoPlayer videoResource={props.videoResource} />;
  }
};

export default RenderedPlayer;
